import { createContext, useContext } from 'react'
import { SocialListeningApi, socialListeningApi } from '@/lib/api'

const SocialListeningApiContext = createContext<SocialListeningApi>(socialListeningApi)

/** The back office scopes the Library's social UI to one org by providing that org's API. */
export const SocialListeningApiProvider = SocialListeningApiContext.Provider

export function useSocialListeningApi(): SocialListeningApi {
  return useContext(SocialListeningApiContext)
}
